import React from 'react'
import { inject, observer } from 'mobx-react'
import classnames from 'classnames'
import Icon from 'components/common/Icon'
import Toggle from 'components/common/Toggle'
import { withTranslation } from 'react-i18next'

const SharedTargetGroupHeader = ({
  uiStore, dataStore, toggle, name, badgeNumber, visibility, extraConfig, extraClasses, t
}) => (
  <div
    className={classnames({ expanded: uiStore[toggle] }, extraClasses)}
    onClick={() => { uiStore[toggle] = !uiStore[toggle] }}
  >
    <div className='shared-with-me__info'>
      <span className='expand-collapse'>
        <Icon id='arrow-right-bold' />
      </span>
      <span className='name'>
        {name}
        {
          badgeNumber !== undefined
            ? <span className='badge'>{badgeNumber}</span>
            : null
        }
      </span>
    </div>
    <div className='shared-with-me__controls'>
      <Toggle
        icon={dataStore.sortConfig.dir === 'asc' ? 'fa-sort-alpha-asc' : 'fa-sort-alpha-desc'}
        title={dataStore.sortConfig.dir === 'asc' ? t('TOOLTIP.SORT_OFF') : t('TOOLTIP.SORT_ON')}
        extraClasses={['right-toggle', 'toggle-sort']}
        enabled={dataStore.sortConfig.dir !== 'asc'}
        onClick={(e) => {
          dataStore.sortTargetGroups(extraConfig.sorting)
          e.stopPropagation()
        }}
      />
      <Toggle
        icon='eye'
        title={t('TOOLTIP.SHOW_HIDE_TARGET')}
        extraClasses={['right-toggle', 'toggle-all-shared']}
        enabled={visibility.visible}
        onClick={(e) => {
          dataStore.sharedTargetGroups.map(group => (
            group.visible = !visibility.visible
          ))
          visibility.visible = !visibility.visible
          e.stopPropagation()
        }}
      />
    </div>
  </div>
)

export default withTranslation()(inject('uiStore', 'dataStore')(observer(SharedTargetGroupHeader)))
